import React from "react";

import { useTranslation } from "react-i18next";

import { FormDateInput } from "@/uiKit/molecules/form/FormDateInput.tsx";

export type TermDateFormFieldProps = {
  name?: string;
  className?: string;
};

export const TermDateFormField: React.FC<TermDateFormFieldProps> = ({ name = "termDate", className }) => {
  const { t } = useTranslation();

  return (
    <FormDateInput
      id="term-date-form-field"
      name={name}
      label={t("diabetesForms.termDate")}
      labelType="left"
      className={className}
      reserveErrorSpace
    />
  );
};
